import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { ElementType, HTMLAttributes, forwardRef } from "react";

export type BadgeVariant =
  | "primary"
  | "secondary"
  | "light"
  | "dark"
  | "danger"
  | "warning";

export interface BadgeProps extends HTMLAttributes<HTMLElement> {
  variant?: BadgeVariant;
  pill?: boolean;
  as?: ElementType;
}

const Badge = forwardRef<HTMLElement, BadgeProps>((props, ref) => {
  const {
    as: Component = "span",
    variant = "primary",
    pill = false,
    className,
    ...rest
  } = props;

  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge(
        clsx("text-[80%] rounded-md py-0.5 px-1.5", {
          "rounded-full": pill,
          "bg-primary text-white": variant === "primary",
          "bg-primary-light text-primary-dark": variant === "secondary",
          "bg-gunmetal-50 text-gunmetal-900": variant === "light",
          "bg-gunmetal-700 text-white": variant === "dark",
          "bg-red-500 text-white": variant === "danger",
          "bg-yellow-500 text-gunmetal-900": variant === "warning",
        }),
        className
      )}
    />
  );
});

export default Badge;
